import { render } from "./QueuedActivityShipmentInfo.vue?vue&type=template&id=52cd110b&scoped=true"
import script from "./QueuedActivityShipmentInfo.vue?vue&type=script&lang=js"
export * from "./QueuedActivityShipmentInfo.vue?vue&type=script&lang=js"

import "./QueuedActivityShipmentInfo.vue?vue&type=style&index=0&id=52cd110b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cd110b"]])

export default __exports__